import styled from 'styled-components'

export const Container = styled.div`
    position: fixed;

    .all-filter-modal {
        overflow: unset;

        .modal-dialog {
            margin-top: 50px;

            .modal-content {
                .modal-body {
                    max-height: calc(100vh - 220px);
                    overflow-y: auto;
                }

                .modal-footer {
                    box-shadow: 0px -4px 0px rgba(0, 0, 0, 0.12);
                }
            }
        }
    }

    .btn-more {
        display: none;
    }

    .show-initiative-summary-modal {
        .modal-content {
            margin-top: 70px;

            width: unset;
            padding: 0px !important;

            .modal-header {
                display: flex !important;
                justify-content: right;
    
                .icon,
                .modal-title {
                    display: none;
                }
    
                .btn-modal-close {
                    margin: 5px 10px 0 0;
                }
            }

            .modal-body {
                .modal-description {
                    margin-bottom: 0px !important;
                }

                .initiative-resume {
                    border: unset;
                }
            }

            .modal-footer {
                display: none;
            }
        }
    }

    .leaflet-container {
        width: 100vw;
        height: calc(100vh - 56px);
    }

    .leaflet-top.leaflet-left {
        top: 16px;
        left: 16px;
    }

    .leaflet-control-zoom.leaflet-bar {
        display: flex;
        flex-direction: column;
        gap: 8px;
        margin: 0;
        border: 0;
        border-radius: 0;
        box-shadow: none;

        a,
        a:hover,
        a:focus {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 44px;
            height: 44px;
            line-height: 1;
            border: 0;
            border-radius: 14px;
            background: #fff;
            color: #516274;
            font-size: 22px;
            font-weight: 600;
            box-shadow: 0 8px 20px rgba(81, 98, 116, 0.14);
            text-decoration: none;
        }

        a:hover {
            background: #fff8e1;
            color: #516274;
        }
    }

    .leaflet-popup-content{
        margin: 15px;

        .map-content {
            .title {
                color: #000;
                font-size: 16px;
                font-weight: 900;
                margin: 8px;
            }
            
            .description {
                color: #000;
                font-size: 14px;
                font-weight: 400;
                margin: 8px;
            }

            button {
                padding: 14px 16px;
                height: 34px;
            }
        }
    }

    .filter {
        position: absolute;
        display: flex;
        flex-direction: row;
        align-items: center;
        margin: 16px 16px 16px 76px;
        z-index: 1111;

        .filter-search {
            .search {
                width: 273px;
            }

            .ui.selection.dropdown {
                display: flex;
                align-items: center;
                background: #fff;
                border: none;
                border-radius: 12px;
                box-shadow: 0 8px 20px rgba(81, 98, 116, 0.14);
                min-height: 44px;
                height: 44px;
                padding: 0 40px 0 40px;
                color: #516274;
                line-height: 44px;

                &::before {
                    content: '';
                    position: absolute;
                    left: 14px;
                    top: 50%;
                    width: 16px;
                    height: 16px;
                    transform: translateY(-50%);
                    pointer-events: none;
                    background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23516274' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Ccircle cx='11' cy='11' r='7'/%3E%3Cpath d='M20 20l-3.5-3.5'/%3E%3C/svg%3E") center / 16px no-repeat;
                }

                &.active,
                &.visible {
                    border-radius: 12px 12px 0 0;
                    z-index: 20;
                }

                > .text,
                > .default.text,
                > input.search {
                    display: flex;
                    align-items: center;
                    height: 44px;
                    line-height: 44px;
                    margin: 0;
                    padding: 0;
                    border-radius: 0;
                }

                &.active > input.search,
                &.visible > input.search {
                    left: 40px !important;
                    width: calc(100% - 80px) !important;
                    padding: 0 !important;
                }

                > .text img,
                > .text .image {
                    display: none;
                }

                > .menu {
                    top: 100% !important;
                    margin-top: 0;
                    padding: 6px 0;
                    border-right: 0;
                    border-bottom: 0;
                    border-left: 0;
                    border-top: 1px solid #e6ebf0 !important;
                    border-radius: 0 0 12px 12px;
                    box-shadow: 0 16px 28px rgba(81, 98, 116, 0.16);

                    > .item {
                        display: flex;
                        align-items: center;
                        min-height: 44px;
                        padding: 8px 14px;

                        img,
                        .image {
                            width: 24px !important;
                            height: 24px !important;
                            margin: 0 10px 0 0 !important;
                        }
                    }
                }

                > .dropdown.icon {
                    top: 50%;
                    right: 16px;
                    width: 8px;
                    height: 8px;
                    margin: 0;
                    padding: 0;
                    font-size: 0;
                    line-height: 0;
                    border-right: 1.75px solid #516274;
                    border-bottom: 1.75px solid #516274;
                    transform: translateY(-75%) rotate(45deg);

                    &::before {
                        content: none;
                    }
                }
            }
        }

        .ui {
            &.menu {
                .ui {
                    &.dropdown {
                        .menu {
                            .item {
                                &.active {
                                    background: #F4C600 !important;
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    .ui {
        &.menu {
            border: unset;
            margin: 0px;
            margin-left: 48px;
            min-height: 44px;
            background: transparent;
            width: 933px;
            justify-content: space-between;

            .link {
                &.item {
                    padding: 0px;
                    box-shadow: 0 8px 20px rgba(81, 98, 116, 0.14);
                    border-radius: 12px;

                    .btn-all {
                        background: #fff;
                        color: #516274;
                        height: 44px;
                        border-radius: 12px;
                        padding: 0 18px;
                    }
                }
            }

            .ui {
                &.dropdown {
                    &.item {
                        font-weight: 600;
                        padding: 0 16px;
                        background: #fff;
                        height: 44px;
                        border-radius: 12px;
                        box-shadow: 0 8px 20px rgba(81, 98, 116, 0.14);

                        .text,
                        .icon {
                            color: #516274;
                        }

                        .menu {
                            top: calc(100% + 8px) !important;
                            margin-top: 0;
                            padding: 8px 0;
                            background: #FFFFFF;
                            box-shadow: 0 16px 36px rgba(81, 98, 116, 0.16);
                            border-radius: 16px;
                            
                            &:not(.city) {
                                max-height: calc(100vh - 150px);
                                overflow: auto;
                            }

                            &.city {
                                overflow: visible;
                            }

                            .header {
                                color: #1C1B1F;
                                padding: 8px 12px;
                            }

                            &.thematic {
                                width: 465px;

                                .item {
                                    .content {
                                        display: flex;
                                        white-space: break-spaces;

                                        .text {
                                            margin-left: 20px;

                                        }
                                    }
                                }
                            }

                            &::after {
                                display: none;
                            }

                            .item {
                                padding: 8px 12px !important;
                                overflow: visible;
                                
                                &.first {
                                    padding: 0px !important;
                                    
                                    > .ui.dropdown {
                                        display: flex;
                                        align-items: center;
                                        justify-content: space-between;
                                        width: 100%;
                                        height: auto;
                                        padding: 8px 12px !important;
                                        background: transparent;
                                        box-shadow: none;
                                        border-radius: 0;

                                        > .text {
                                            color: #1C1B1F;
                                        }

                                        > .dropdown.icon {
                                            margin: 0 0 0 12px;
                                            transform: rotate(-90deg);
                                        }

                                        > .menu {
                                            top: 0 !important;
                                            margin-top: 0;
                                            left: calc(100% + 8px) !important;
                                            right: auto !important;
                                            min-width: 240px;
                                            max-height: calc(100vh - 180px);
                                            overflow: auto;
                                            background: #fff;
                                            border-radius: 16px;
                                        }
                                    }
                                }
                                
                                .text {
                                    color: #1C1B1F;
                                }

                                .checkbox {
                                    label {
                                        padding-left: 34px;
                                        font-weight: 400;
                                        font-size: 12px;
                                        line-height: 18px;
                                        min-height: 18px;
                                        color: #1C1B1F;
                                        overflow: visible;

                                        &::before {
                                            top: 0;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    @media (max-width: 575.98px) {
        .ui {
            &.menu {
                margin-left: 0px;
            }
        }

        .all-filter-modal {
            overflow: unset;
    
            .modal-dialog {
                margin-top: 33px;
                max-width: fit-content;
                
                .modal-content {
                    .modal-body {
                        max-height: calc(100vh - 200px);
                    }
                }
            }
        }
    }

    @media (min-width: 767.99px) and (max-width: 991.98px) {
        .filter {
            display: block;
            
            >div {
                margin-bottom: 8px;
            }

            .ui {
                &.menu {
                    display: table-row;

                    >div {
                        margin-bottom: 8px;
                        width: max-content;
                    }
                }
            }
        }
    }
`